import { render, staticRenderFns } from "./FlippableCard.vue?vue&type=template&id=4be274b1&"
import script from "./FlippableCard.vue?vue&type=script&lang=js&"
export * from "./FlippableCard.vue?vue&type=script&lang=js&"
import style0 from "./FlippableCard.vue?vue&type=style&index=0&id=4be274b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports